import { useRecoilValue } from 'recoil';
import { ActionsCell } from '../../../Component/Common/Components/DataTable/ActionsCell';
import { DefaultCell } from '../../../Component/Common/Components/DataTable/DefaultCell';
import { BEE123SalariesEditRole, UserAdminRole } from '../../../Component/Common/Constants/UserRoles';
import { PeopleDtos } from '../../../Component/Model/Dto/People';
import { DateFormatter } from '../../../Component/Model/helpers';
import { ActionType, TableColumn } from '../../../Component/Model/Table/Table';
import { userRolesState } from '../../../State/user.Atom';

interface PeopleSalariesTableRow {
    ID: number,
    IdentificationNumber: string,
    EmployeeCode: string,
    FullName: string,
    Race: string,
    Gender: string,
    Disabled: string,
    CreatedDate: string,
    CreatedBy: string,
    Actions?: any,
}

export interface IPeopleSalariesTable {
    columns: Array<TableColumn>;
    rows: Array<PeopleSalariesTableRow>;
}

export function PeopleSalariesTableMapper(results: PeopleDtos.PeopleSearchRow[], onEditPeopleSalariesRow: (id: number) => void): IPeopleSalariesTable {
    const editRoleAccess = [
        BEE123SalariesEditRole,
        UserAdminRole
    ];

    const userRoles = useRecoilValue(userRolesState);
    const isEditable = userRoles.some(r => editRoleAccess.includes(r));

    const columns = [
        { Header: 'ID Number', accessor: 'IdentificationNumber', Cell: ({ value }: any) => <DefaultCell value={value} />, disableSortBy: true  },
        { Header: 'Employee Code', accessor: 'EmployeeCode', Cell: ({ value }: any) => <DefaultCell value={value} />, disableSortBy: true  },
        { Header: 'Full Name', accessor: 'FullName', id: "FirstName", Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Race', accessor: 'Race', id:"RaceId", Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Gender', accessor: 'Gender', id:"GenderId", Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Disabled', accessor: 'Disabled', id:"IsDisabled", Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Created Date', accessor: 'CreatedDate', id: "CreatedDateUtc",Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Actions', accessor: 'Actions', Cell: ({ value }: any) => <ActionsCell actions={value} />, disableSortBy: true },
    ];
    if (results.length >= 0) {
        const rows = results.map((item: PeopleDtos.PeopleSearchRow, index: number) => (
            {
                ID: item.id,
                IdentificationNumber: item.identificationNumber,
                EmployeeCode: item.employeeCode,
                FullName: item.fullName,//{ linkTo: `/ee/scorecard/${item.ID}`, itemName: item.Name },
                Race: item.race,
                Gender: item.gender,
                Disabled: item.isDisabled ? 'Yes' : 'No',
                CreatedDate: DateFormatter(item.createdDate.toString()),
                CreatedBy: item.createdBy,

                Actions: [
                    isEditable ?
                        {
                            key: index.toString(),
                            label: 'Edit Salaries',
                            action: () => {
                                onEditPeopleSalariesRow(item.id);
                            },
                            icon: {
                                color: 'info',
                                name: 'edit'
                            }
                        } :
                        {
                            key: index.toString(),
                            label: 'View Salaries',
                            action: () => {
                                onEditPeopleSalariesRow(item.id);
                            },
                            icon: {
                                color: 'info',
                                name: 'visibility'
                            }
                        }
                ].filter(Boolean) as ActionType[]
            }));

        return { columns: columns, rows: rows };
    }else{
        return { columns: columns, rows: [] };
    }
}
